import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import { getValue } from 'Common/Components/Keyboard/withKeyboard';
import { getValueFromInputMode } from 'Common/GeneralHelper';
import { InputMode } from 'Common/FormEnum';
import { TRANSACTION_FORM_NAME } from 'Common/FormEnum';
import AdditionalFoodItemComponent from 'PointOfSale/modules/individualServing/component/AdditionalFoodItem';
import * as IndividualServingActions from 'PointOfSale/modules/individualServing/state/actions';
import * as POSSelectors from 'PointOfSale/selectors';
import {
  MealTypesEnum,
  MealTypeKeysEnum,
} from 'Common/Constants/Enumeration/MealTypesEnum';

class AdditionalFoodItemContainer extends Component {
  handleDecrement = (event, itemId) => {
    const { IndividualServingActions } = this.props;
    IndividualServingActions.removeItem(itemId);
  };

  handleIncrement = (event, item) => {
    const { IndividualServingActions } = this.props;
    IndividualServingActions.addItem(item);
  };

  handleRemove = (event, itemId) => {
    const { IndividualServingActions } = this.props;
    IndividualServingActions.removeItem(itemId, true);
  };

  handleInputChange = (event, itemId) => {
    const { IndividualServingActions } = this.props;

    let value = getValue(event);
    value = getValueFromInputMode(InputMode.Decimal, [6, 2], value);
    value = value.replace(/[^\d.]/g, '');
    IndividualServingActions.changeUnitPrice(value, itemId);
  };

  reset = () => {
    this.props.IndividualServingActions.reset();
  };

  render() {
    const {
      activeSession,
      currentTransaction,
      currentSelectedMenu,
    } = this.props;

    const allowUnitPriceModification =
      currentSelectedMenu === MealTypeKeysEnum[MealTypesEnum.Other];

    return (
      <AdditionalFoodItemComponent
        additionalItems={currentTransaction.BoughtItems || []}
        handleDecrement={this.handleDecrement}
        handleIncrement={this.handleIncrement}
        handleRemove={this.handleRemove}
        handleRemoveAllItems={this.reset}
        handleInputChange={this.handleInputChange}
        activeSession={activeSession}
        allowUnitPriceModification={allowUnitPriceModification}
      />
    );
  }
}

AdditionalFoodItemContainer.propTypes = {
  additionalItems: PropTypes.array,
};

const mapStateToProps = state => ({
  transactionFormValues: getFormValues(TRANSACTION_FORM_NAME)(state) || {},
  currentTransaction: POSSelectors.getCurrentTransaction(state),
  activeSession: POSSelectors.getActiveSession(state),
  currentSelectedMenu: POSSelectors.getCurrentSelectedMenu(state),
});

const mapDispatchToProps = dispatch => ({
  IndividualServingActions: bindActionCreators(
    IndividualServingActions,
    dispatch
  ),
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdditionalFoodItemContainer);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/container/AdditionalFoodItem.js